import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import UserForm from '@/modules/user/components/UserForm.vue';
import { User } from '@/modules/user/User';
import { usePartnerRouteLoader } from '@/modules/partner/pages/userCommon';
import { Partner } from '@/modules/partner/Partner';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCreate',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const resource = ref();
const partner = ref<Partner>();
const pageTitle = computed(() => interpolate(
	$gettext('Ny användare för %{ name }'),
	{name: partner.value?.name || ''},
));
const router = useRouter();
const store = useStore<AppStore>();

usePartnerRouteLoader(resource, partner);

const user = ref<Partial<User>>({
	type: 'PARTNER',
	permissions: [],
	language: store.getters.userLanguage,
});

const saved = (user) => {
	Flash.success($gettext('Användare tillagd'));
	router.push({
		name: 'partner.user.edit',
		params: { id: user.id },
	});
};

const cancel = () => {
	router.push({ name: 'partner.user.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserForm, {
    resource: resource.value,
    "page-title": pageTitle.value,
    user: user.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["resource", "page-title", "user"]))
}
}

})